import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Badge } from '../ui/Badge';

type Col = { heading: string; links: { label: string; to: string }[] };

const COLUMNS: Col[] = [
  {
    heading: 'Product',
    links: [
      { label: 'Ship a package', to: '/shipping' },
      { label: 'Track shipment', to: '/track' },
      { label: 'Services', to: '/services' },
      { label: 'Pricing & volumetric', to: '/volumetric-weight' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Contact', to: '/contact' },
      { label: 'FAQ', to: '/faq' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Terms', to: '/terms' },
      { label: 'Privacy', to: '/privacy' },
    ],
  },
];

export const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-inner">
      <div className="footer-brand">
        <Logo mono />
        <p className="muted" style={{ marginTop: 12, fontSize: 14, maxWidth: 320 }}>
          Shipping infrastructure for modern businesses. Compare carriers, book in seconds, track from one place.
        </p>
        <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
          <Badge>EN · AR</Badge>
          <Badge>ILS · USD</Badge>
        </div>
      </div>
      {COLUMNS.map((col) => (
        <div key={col.heading} className="footer-col">
          <h4>{col.heading}</h4>
          {col.links.map((l) => (
            <Link key={l.to} to={l.to}>
              {l.label}
            </Link>
          ))}
        </div>
      ))}
    </div>
    <div className="footer-bottom">
      <span className="muted" style={{ fontSize: 13 }}>
        © {new Date().getFullYear()} Almaship · Imperia Tech LLC · support@almaship.co · +1 (302) 237-9963
      </span>
      <span className="muted mono" style={{ fontSize: 12 }}>
        v3.0 — Atlas
      </span>
    </div>
  </footer>
);

export default Footer;
